import type { LucideIcon } from 'lucide-react';
import { MailIcon, PhoneIcon } from 'lucide-react';

export interface FooterContactItem {
  contactField: string;
  hrefAction: string;
  copyAriaLabel: string;
  icon: LucideIcon;
}

export const footerContactItems: FooterContactItem[] = [
  {
    contactField: 'Contact@nexgo.ai',
    hrefAction: `mailto:Contact@nexgo.ai`,
    copyAriaLabel: 'Copy email',
    icon: MailIcon,
  },
  {
    contactField: '+918075073599',
    hrefAction: `tel:+918075073599`,
    copyAriaLabel: 'Copy phone number',
    icon: PhoneIcon,
  },
];
